import { useContext, useState, FC, useEffect } from 'react'

import { Jobsite, JobsiteFilterKeyString } from 'InstitutionalManagement/types'
import { JOBSITE_INITIAL_FILTER } from 'InstitutionalManagement/constants/pages/jobsites'
import CustomFormJobsiteSelectionDrawerManagerContext from './Context'
import readJobsitesOnCustomForm from './services/readJobsitesOnCustomForm'

type Props = {
  questionKey: string
  children: JSX.Element
}

const CustomFormJobsiteSelectionDrawerManagerProvider: FC<Props> = ({ questionKey, children }) => {
  const [view, setView] = useState<string>('SEARCH_JOBSITE')
  const [selectedJobsite, setSelectedJobsite] = useState<Jobsite>({})
  const [loadingJobsites, setLoadingJobsites] = useState<boolean>(true)
  const [jobsites, setJobsites] = useState<Jobsite[]>([])
  const [filter, setFilter] = useState<JobsiteFilterKeyString>(JOBSITE_INITIAL_FILTER)

  async function loadJobsite() {
    setLoadingJobsites(true)
    const filters = {
      filter,
      pagination: {
        page: 1,
        limit: 100,
      },
    }

    const response = await readJobsitesOnCustomForm({ filters })

    if (response?.header?.success) {
      const jobsitesFromAPI = response?.body?.jobsite?.elements
      setJobsites(jobsitesFromAPI || [])
    }
    setLoadingJobsites(false)
  }

  useEffect(() => {
    if (view != 'SEARCH_JOBSITE') loadJobsite()
  }, [filter])

  return (
    <CustomFormJobsiteSelectionDrawerManagerContext.Provider
      value={{
        view,
        setView,
        selectedJobsite,
        setSelectedJobsite,
        filter,
        setFilter,
        questionKey,
        jobsites,
        loadingJobsites,
        setLoadingJobsites,
      }}
    >
      {children}
    </CustomFormJobsiteSelectionDrawerManagerContext.Provider>
  )
}

export const useCustomFormJobsiteSelectionDrawerManager = () =>
  useContext(CustomFormJobsiteSelectionDrawerManagerContext)

export default CustomFormJobsiteSelectionDrawerManagerProvider
